<mat-button-toggle-group
    class="filter-chips-toggle-group mb-4 flex w-full flex-wrap gap-2"
    [class.mode-togglers]="formItem === queryParameter.mode"
    [multiple]="multiple"
    [formControl]="formGroup.get(formItem)"
    aria-labelledby="trafficLabel">
    <mat-button-toggle
        class="mat-ripple var-app-light:bg-white var-app-light:text-primary orb-app-light-dark:font-semibold bg-grey-white_smoke text-sm dark:bg-contrast-black dark:text-contrast-yellow"
        *ngFor="let value of values"
        [value]="value.VALUE">
        <ng-container *ngIf="formItem === queryParameter.mode; else noModeContent" [ngSwitch]="value.VALUE" else;>
            <img
                class="dark:filter-yellow"
                *ngSwitchCase="transportMode.Rail"
                [src]="(assetsPath$ | async) + '/img/journey-planner/train.svg'"
                aria-label="{{ 'MODAL_GROUPED_TRAIN' | translate }}"
                title="{{ 'MODAL_GROUPED_TRAIN' | translate }}" />
            <img
                class="dark:filter-yellow"
                *ngSwitchCase="transportMode.Bus"
                [src]="(assetsPath$ | async) + '/img/journey-planner/bus.svg'"
                aria-label="{{ 'BUS' | translate }}"
                title="{{ 'BUS' | translate }}" />
            <img
                class="dark:filter-yellow"
                *ngSwitchCase="transportMode.Ferry"
                [src]="(assetsPath$ | async) + '/img/journey-planner/ferry.svg'"
                aria-label="{{ 'FERRY' | translate }}"
                title="{{ 'FERRY' | translate }}" />
        </ng-container>
        <ng-template #noModeContent>
            <div
                class="var-app-light-dark:text-black toggle-content px-3"
                [class.uppercase]="!env.REMOVE_UPPERCASE"
                (click)="itemClick($event, value)">
                {{ value.KEY ? (value.KEY | translate) : value.VALUE }}
            </div>
        </ng-template>
    </mat-button-toggle>
</mat-button-toggle-group>
